import { ContentCopy as CopyIcon, CheckCircle as CheckIcon } from "@mui/icons-material";
import Popup from "./Popup";
import FilledButton from "./FilledButton";

export default function LicenseKeyModal({ 
  isOpen, 
  onClose, 
  licenseKey = "", 
  licenseId = "",
  onCopyToClipboard 
}) {
  if (!isOpen) return null;

  return (
    <Popup
      popupTitle="License Generated Successfully"
      onClose={onClose}
      width="max-w-2xl"
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-emerald-100 rounded-lg flex items-center justify-center">
          <CheckIcon className="w-6 h-6 text-emerald-600" />
        </div>
        <div className="text-sm text-gray-600">
          Your license has been generated successfully. Please save the license key securely.
        </div>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-900 mb-2">
            License ID
          </label>
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={licenseId}
              readOnly
              className="flex-1 px-3 py-2 border border-slate-200 rounded-lg bg-slate-50 font-mono text-sm text-slate-900"
            />
            <button
              onClick={() => onCopyToClipboard(licenseId)}
              className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
              title="Copy License ID"
            >
              <CopyIcon className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-900 mb-2">
            License Key
          </label>
          <div className="flex items-start gap-2">
            <textarea
              value={licenseKey}
              readOnly
              rows={4}
              className="flex-1 px-3 py-2 border border-slate-200 rounded-lg bg-slate-50 font-mono text-sm text-slate-900 resize-none"
            />
            <button
              onClick={() => onCopyToClipboard(licenseKey)}
              className="p-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100 rounded-lg transition-colors"
              title="Copy License Key"
            >
              <CopyIcon className="w-5 h-5" />
            </button>
          </div>
          {/* <div className="mt-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-xs text-amber-800">
              ⚠️ <strong>Important:</strong> Save this license key
              securely. It will not be shown again.
            </p>
          </div> */}
        </div>
      </div>
    </Popup>
  );
}
